// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"l2-z","colorTextValue":"m2-z","swatches":"n2-z","collapseLink":"o2-z","isCollapsed":"p2-z","dropdown":"q2-z","disabled":"r2-z"};